import styled, {css} from "styled-components";
import {PanelProps, Variant} from "./Panel";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  background: ${({theme}) => theme.colors.secondaryBackground};
  min-height: 50px;

  @media only screen and (${({theme}) => theme.media.large}) {
    border-radius: 40px;
  }
`

export const PanelHeader = styled.div<PanelProps>`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({theme, variant}) => variant === Variant.Default ? theme.colors.red : theme.business.colors.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase;
  margin: auto 0;

  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 20px 50px 20px 100px;
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
  }
`

export const PanelBody = styled.div`
  padding: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  color: ${({theme}) => theme.colors.text};

  @media only screen and (${({theme}) => theme.media.large}) {
    padding-left: 100px;
    padding-bottom: 20px;
    font-size: 24px;
    line-height: 50px;
    
    & > div {
      width: 80%;
    }
  }
`

export const PanelButton = styled.div<{open: boolean, variant: Variant}>`
  & svg {
    width: 16px;
    height: 16px;
    transition: all 500ms linear;
    ${({open}) => open ? css`transform: rotate(90deg);` : css`transform: rotate(270deg);`};
    path {
      fill: ${({theme, variant}) => variant === Variant.Default ? theme.colors.red : theme.business.colors.primary};
    }
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    background: ${({theme}) => theme.colors.thirdlyBackground};
    width: 60px;
    height: 60px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    & svg {
      transition: all 500ms linear;
      ${({open}) => open ? css`transform: rotate(180deg)` : css`transform: rotate(360deg)`};
      path {
        fill: ${({theme, variant}) => variant === Variant.Default ? theme.colors.red : theme.business.colors.primary};
      }
    }
  }
`